var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { useToast } from '@pocketlaw/tetris';
import { documentFlush, usePreview } from 'shared/domains/documents';
import { CreateSignRequestErrors, HANDLED_ERRORS } from '../types';
import { useCreateSignRequest } from '../useCreateSignRequest';
export const useSendForEsigning = (documentId) => {
    const { createSignRequest, convertToPdf } = useCreateSignRequest();
    const { isRtcAvailable } = usePreview();
    const { addToast } = useToast();
    const [loading, setLoading] = useState(false);
    const [submitCount, setSubmitCount] = useState(0);
    const [creationError, setCreationError] = useState();
    const [creationFailedSubcode, setCreationFailedSubcode] = useState();
    const [creationRejectionReasons, setCreationRejectionReasons] = useState([]);
    const convertDocumentToPdf = () => __awaiter(void 0, void 0, void 0, function* () { return convertToPdf(documentId); });
    const sendForEsigning = (pdf) => __awaiter(void 0, void 0, void 0, function* () {
        if (isRtcAvailable) {
            documentFlush({ state: 'initialized' });
        }
        setLoading(true);
        setCreationError(undefined);
        setCreationFailedSubcode(undefined);
        setSubmitCount((current) => current + 1);
        createSignRequest(documentId, pdf)
            .then((result) => {
            var _a, _b;
            // eslint-disable-next-line no-underscore-dangle
            if (((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.createSignRequest) === null || _b === void 0 ? void 0 : _b.__typename) === 'CreateSignRequestRejectionList') {
                setCreationRejectionReasons(result.data.createSignRequest.rejections.map((rejection) => rejection.reason));
            }
        })
            .catch((mutationError) => {
            addToast({
                appearance: 'danger',
                title: t({
                    message: 'Could not send document for e-signing.',
                    comment: 'Message for when a user tries to send a document for e-signing but something went wrong',
                }),
            });
            const error = mutationError;
            const { message } = error;
            if (HANDLED_ERRORS.includes(message)) {
                setCreationError(message);
            }
            else {
                setCreationError(CreateSignRequestErrors.UnexpectedError);
            }
        })
            .finally(() => {
            setLoading(false);
        });
    });
    return {
        sendForEsigning,
        convertDocumentToPdf,
        loading,
        submitCount,
        creationError,
        creationFailedSubcode,
        creationRejectionReasons,
        setCreationFailedSubcode,
    };
};
